export default __webpack_public_path__ + "adea671b7e718f618d945297e700ec9c.jpg";